import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicOgudu from "../Components/ProjPicOgudu";

const ProjectPageOgudu = () => {
    return (
        <>
            <Navbar />
            <ProjPicOgudu />
            <Footer />
        </>
    );
};

export default ProjectPageOgudu;
